/**
 * @NOTE
 * @InitialValues  - are equivalent to Types When in Used in Type Script
 */

const address = {
  barangay: "",
  municipality: "",
  province: "",
  region: "",
};

export const establishmentInitialValue = {
  category: "",
  name: "",
  street: "",
  zipcode: "",
  ...address,
};
